const thenGenerateUserUuid = require("./thenGenerateUserUuid");
const thenAddUuidInputToAllFormsOnThePage = require("./thenAddUuidInputToAllFormsOnThePage");

/**
 * @param data {Data}
 */
module.exports = function whenAcceptedCookiesChanged(data) {
  thenGenerateUserUuid(data);
  thenAddUuidInputToAllFormsOnThePage(data);
};
